export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
  case 'SPECIES_SET':
    return payload
  case 'LOGOUT':
    return []
  default:
    return state
  }
}
